import { UserRole } from '../generated/graphql';

const HOTEL_PORTAL_ROLES = [
  UserRole.ClientAdmin,
  UserRole.ClientUser,
  UserRole.ClientReadOnly,
  UserRole.ClientTraveler,
];

export const hasHotelPortalAccess = (roles: UserRole[] | null | undefined) =>
  roles?.some((role) => HOTEL_PORTAL_ROLES.includes(role)) ?? false;
